import Block from '../../block'

export default class ShoppingcartPayment extends Block {
	static title = 'shoppingcart-payment'

	constructor($el) {
		super($el)

		this.providerSelect = this.$el.find('sl-select[name="payment_id"]')
		this.providerImg = this.$el.findElement('method-img')
		this.methodSelect = this.$el.find('sl-select[name="method"]')
		this.methodImg = this.$el.findElement('method-img')

		this.providerSelect.on('sl-change', (e) => {
			const current = $(e.currentTarget).find('sl-option[aria-selected="true"]')
			if (current.val()) {
				this.providerImg.find('img').attr(
					'src',
					'/_frontend/img/payment-icons/' +
						current
							.data('title')
							.toLowerCase()
							.replace(/[\s,%.]+/g, '_') +
						'.svg',
				)
				this.providerImg.addClass('flex')
				this.providerImg.removeClass('hidden')
			} else {
				this.providerImg.removeClass('flex')
				this.providerImg.addClass('hidden')
			}
		})

		this.methodSelect.on('sl-change', (e) => {
			const current = $(e.currentTarget).find('sl-option[aria-selected="true"]')
			if (current.val()) {
				this.methodImg.find('img').attr(
					'src',
					'/_frontend/img/payment-icons/' +
						current
							.data('title')
							.toLowerCase()
							.replace(/[\s,%.]+/g, '_') +
						'.png',
				)
				this.methodImg.addClass('flex')
				this.methodImg.removeClass('hidden')
			} else {
				this.methodImg.removeClass('flex')
				this.methodImg.addClass('hidden')
			}
		})

		if (this.$el.hasModifier('autosubmit')) {
			const paymentProviderSelect = this.$el.find(
				'sl-select[name="payment_id"]',
			)
			paymentProviderSelect.on('sl-change', () => {
				this.$el.submit()
			})
		}
	}
}
